const shifts = {
  form: {
    information: {
      directionOptions: {
        from: 'Da escola',
        to: 'Para a Escola',
        both: 'Para a Escola & Da Escola',
      },
    },
  },
};

export default shifts;
